export const CREATE_PHONE = 'CREATE_PHONE';
export const CREATE_EMAIL = 'CREATE_EMAIL';
export const CREATE_PASSWORD = 'CREATE_PASSWORD';

export const CREATE_PHONE_STATUS = 'CREATE_PHONE_STATUS';
export const CREATE_EMAIL_STATUS = 'CREATE_EMAIL_STATUS';
export const CREATE_PASSWORD_STATUS = 'CREATE_PASSWORD_STATUS';

